import { useState } from "react";
import { BusinessValueTab } from "./PoMismatch/BusinessValueTab";
import { HelpdeskQueueTab } from "./PoMismatch/HelpdeskQueueTab";
import { ResolutionAgentTab } from "./PoMismatch/ResolutionAgentTab";
import { TicketInsightsTab } from "./PoMismatch/TicketInsightsTab";
import { Ticket } from "./PoMismatch/types";

type ResolutionTab = "helpdesk" | "agent" | "insights" | "value";

const TABS: { id: ResolutionTab; label: string }[] = [
  { id: "helpdesk", label: "Helpdesk Queue" },
  { id: "agent", label: "Resolution Agent" },
  { id: "insights", label: "Ticket Insights & Model" },
  { id: "value", label: "Business Value" },
];

export function POMismatchResolutionView() {
  const [activeTab, setActiveTab] = useState<ResolutionTab>("helpdesk");
  const [selectedTicket, setSelectedTicket] = useState<Ticket | null>(null);

  const handleTicketSelect = (ticket: Ticket) => {
    setSelectedTicket(ticket);
    setActiveTab("agent");
  };

  return (
    <div className="po-mismatch screen-enter">
      <div className="po-mismatch__content">
        <div className="po-mismatch__header">
          <div>
            <p className="po-mismatch__eyebrow">Purchase Order</p>
            <h2 className="po-mismatch__title">PO Mismatch Query Resolution</h2>
          </div>
        </div>

        <div className="po-mismatch__tabs" role="tablist" aria-label="PO mismatch workflow">
          {TABS.map((tab) => (
            <button
              key={tab.id}
              type="button"
              role="tab"
              aria-selected={activeTab === tab.id}
              className={`po-mismatch__tab${activeTab === tab.id ? " is-active" : ""}`}
              onClick={() => setActiveTab(tab.id)}
            >
              {tab.label}
            </button>
          ))}
        </div>

        {activeTab === "helpdesk" && <HelpdeskQueueTab onTicketSelect={handleTicketSelect} />}
        {activeTab === "agent" && selectedTicket && <ResolutionAgentTab selectedTicket={selectedTicket} onBackToQueue={() => setActiveTab("helpdesk")} onViewInsights={() => setActiveTab("insights")} />}
        {activeTab === "insights" && <TicketInsightsTab />}
        {activeTab === "value" && <BusinessValueTab />}
      </div>
    </div>
  );
}
